import { NotificationServicePath } from "utils/constants";

export const notificationsRequests = {
  getEmailGroupsSelect: () => `${NotificationServicePath}emails/groups/select`,
  getEmailHtmlBody: id => `${NotificationServicePath}emails/${id}/html-body`,
  resendEmail: id => `${NotificationServicePath}emails/${id}/resend`,
};
